import React, { useState, useEffect } from "react";
import { gql, useQuery } from "@apollo/client";

const GET_PRODUCTOS = gql`
  query GetProductos {
    getProductos {
      _id
      nombre
      proveedores
    }
  }
`;

function PreciosProveedores() {

  // =========================
  // BUSCADOR
  // =========================
  const [inputBusqueda, setInputBusqueda] = useState("");
  const [busqueda, setBusqueda] = useState("");

  // =========================
  // CARRITO
  // =========================
  const [carrito, setCarrito] = useState([]);

  // =========================
  // MODAL
  // =========================
  const [mostrarModal, setMostrarModal] = useState(false);

  const { loading, error, data } = useQuery(GET_PRODUCTOS);

  // =========================
  // CARGAR LOCALSTORAGE
  // =========================
  useEffect(() => {
    const carritoGuardado = localStorage.getItem("carrito");

    if (carritoGuardado) {
      setCarrito(JSON.parse(carritoGuardado));
    }
  }, []);

  // =========================
  // GUARDAR LOCALSTORAGE
  // =========================
  useEffect(() => {
    localStorage.setItem("carrito", JSON.stringify(carrito));
  }, [carrito]);

  // =========================
  // DEBOUNCE
  // =========================
  useEffect(() => {
    const timeout = setTimeout(() => {
      setBusqueda(inputBusqueda);
    }, 300);

    return () => clearTimeout(timeout);
  }, [inputBusqueda]);

  // =========================
  // AGREGAR AL CARRITO
  // =========================
  const agregarAlCarrito = (producto) => {

    const existe = carrito.find(
      (item) => item._id === producto._id
    );

    if (existe) {
      alert("Producto ya agregado");
      return;
    }

    // PROVEEDOR BUSCADO
    const proveedorSeleccionado = busqueda || "Sin proveedor";

    // PRODUCTO NUEVO
    const productoConFecha = {
      ...producto,
      proveedorSeleccionado,
      fechaAgregado: new Date().toLocaleString()
    };

    setCarrito([...carrito, productoConFecha]);
  };

  // =========================
  // ELIMINAR PRODUCTO
  // =========================
  const eliminarDelCarrito = (id) => {

    const nuevoCarrito = carrito.filter(
      (item) => item._id !== id
    );

    setCarrito(nuevoCarrito);
  };

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error.message}</p>;

  // =========================
  // FILTRO + ORDEN ALFABÉTICO
  // =========================
  const productosFiltrados =
    data?.getProductos
      ?.filter((producto) => {

        if (!busqueda) return true;

        const proveedores = Array.isArray(producto.proveedores)
          ? producto.proveedores
          : [producto.proveedores];

        return proveedores.some((prov) =>
          prov?.toLowerCase().includes(busqueda.toLowerCase())
        );
      })
      ?.sort((a, b) =>
        a.nombre
          .toLowerCase()
          .localeCompare(b.nombre.toLowerCase())
      ) || [];

  return (
    <div style={{ padding: 20 }}>

      {/* BOTÓN CARRITO */}
      <button
        onClick={() => setMostrarModal(true)}
        style={{
          marginBottom: 20,
          background: "#045712",
          color: "#fff",
          border: "none",
          padding: "12px 20px",
          borderRadius: 10,
          cursor: "pointer",
          fontSize: 16
        }}
      >
        ver pedidos
      </button>

      {/* INPUT */}
      <div style={{ marginBottom: 25 }}>
        <input
          type="text"
          placeholder="Buscar proveedor..."
          value={inputBusqueda}
          onChange={(e) => setInputBusqueda(e.target.value)}
          style={{
            width: "100%",
            maxWidth: 400,
            padding: 12,
            borderRadius: 10,
            border: "1px solid #ccc",
            fontSize: 16
          }}
        />
      </div>

      {/* TARJETAS */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit,minmax(320px,1fr))",
          gap: 20
        }}
      >
        {productosFiltrados.map((producto) => (
          <div
            key={producto._id}
            style={{
              border: "1px solid #ddd",
              borderRadius: 12,
              padding: 20,
              background: "#00ff4c1c",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
            }}
          >
            <h4
              style={{
                color: "#000",
                marginBottom: 10
              }}
            >
              {producto.nombre}
            </h4>

            <h5 style={{ color: "#154d1d" }}>
              <strong>Proveedores:</strong>{" "}
              {Array.isArray(producto.proveedores)
                ? producto.proveedores.join(", ")
                : producto.proveedores || "sin agregar"}
            </h5>

            {/* BOTÓN AGREGAR */}
            <button
              onClick={() => agregarAlCarrito(producto)}
              className="btn btn-salida"
            >
              Agregar
            </button>

          </div>
        ))}
      </div>

      {/* ========================= */}
      {/* MODAL */}
      {/* ========================= */}

      {mostrarModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999
          }}
        >

          {/* CONTENIDO MODAL */}
          <div
            style={{
              width: "90%",
              background: "#fff",
              borderRadius: 15,
              padding: 25,
              overflowY: "auto",
              position: "relative",
              maxHeight: "80vh"
            }}
          >

            {/* BOTÓN CERRAR */}
            <button
              onClick={() => setMostrarModal(false)}
              style={{
                position: "absolute",
                top: 15,
                right: 15,
                background: "#a70303e8",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: 35,
                height: 35,
                cursor: "pointer",
                fontWeight: "bold"
              }}
            >
              X
            </button>

            <h2 style={{ marginBottom: 20 }}>
              Pedidos
            </h2>

            {carrito.length === 0 ? (
              <p>No hay pedidos</p>
            ) : (
              [...carrito]
                .sort((a, b) =>
                  a.nombre
                    .toLowerCase()
                    .localeCompare(b.nombre.toLowerCase())
                )
                .map((item) => (
                  <div
                    key={item._id}
                    style={{
                      borderBottom: "1px solid #ddd",
                      paddingBottom: 15,
                      marginBottom: 15,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 20
                    }}
                  >

                    {/* INFORMACIÓN */}
                    <div>

                      {/* NOMBRE */}
                      <h4>{item.nombre}</h4>

                      {/* FECHA */}
                      <p
                        style={{
                          color: "#666",
                          fontSize: 14,
                          marginTop: 5
                        }}
                      >
                        fecha de pedido: {item.fechaAgregado}
                      </p>

                      {/* PROVEEDOR */}
                      <p
                        style={{
                          color: "#154d1d",
                          fontSize: 14
                        }}
                      >
                        <strong>proveedor:</strong>{" "}
                        {item.proveedorSeleccionado}
                      </p>

                    </div>

                    {/* BOTÓN ELIMINAR */}
                    <button
                      onClick={() =>
                        eliminarDelCarrito(item._id)
                      }
                      style={{
                        background: "#a70303e8",
                        color: "#fff",
                        border: "none",
                        padding: "10px 14px",
                        borderRadius: 8,
                        cursor: "pointer",
                        height: "fit-content",
                        whiteSpace: "nowrap"
                      }}
                    >
                      Eliminar
                    </button>

                  </div>
                ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default PreciosProveedores;